module.exports = __webpack_public_path__ + "img/eye-closed.4c3d1710.svg";